export const EDIT_BUTTON_TOOLTIP_ID = "cslp-tooltip";
